<template>
  <section class="about">
    <heading :ahead="title.ahead" :behind="title.behind" />
    <div class="cover">
      <div class="left">
        <div class="avatar">
          <img src="@/assets/images/about-me.svg" alt="Avatar" />
        </div>
      </div>
      <div class="right">
        <div class="about-me">
          <p>
            As a Software Engineer and UX developer, I understand the complete
            software product life cycle. From requirements to design,
            development to maintenance, I uncover problems and provide the best
            possible stable solutions by applying SDLC principles and industry
            standards.
          </p>
          <p>
            I had a degree in Software Engineering and Experience in developing
            Enterprise applications along with knowledge of cutting edge
            technologies and UX/UI principles.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Heading from "../components/Heading.vue";

export default {
  name: "About",
  components: {
    Heading
  },
  data() {
    return {
      title: {
        ahead: "About",
        behind: "Me"
      }
    };
  }
};
</script>

<style scoped>
.about {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  padding: 30px 0px;
}

.about::before {
  position: absolute;
  content: "";
  background: #f7f7f7;
  width: 65vw;
  height: 15vh;
  z-index: -10;
  transform: translateY(150%);
}

.cover {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0px 7vw;
}

.left {
  width: 50%;
  height: 300px;
  padding: 5px;
  box-sizing: border-box;
}

.avatar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar img {
  width: auto;
  height: 100%;
  box-sizing: border-box;
  object-fit: cover;
}

.right {
  left: 50%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.about-me {
  max-width: 550px;
}

.about-me p {
  line-height: 1.6;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .left {
    display: none;
  }

  .right {
    left: 0%;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
}
</style>
